import React from "react";
import TourCard from "./TourCard";
import "./TourList.css";
import beachImg from './beach.png';
import kandyTempleImg from './kandyTemple.jpg';
import nuwaraEliyaImg from './nuwaraeliya.png';
import bentotaImg from './bentota.png';
import adventureImg from './adventure.jpg';
import { useTranslation } from "./hooks/useTranslation";

const TourList = () => {
  const { t } = useTranslation();

  const tourData = [
    {
      title: t.package1,
      country: "Sri Lanka",
      price: 780,
      duration: 3,
      tags: [t.sigiriya, t.kandy, t.cultural],
      image: kandyTempleImg,
    },
    {
      title: t.package2,
      country: "Sri Lanka",
      price: 1130,
      duration: 5,
      tags: [t.sigiriya, t.kandy, t.hillCountry, t.ella],
      image: nuwaraEliyaImg,
    },
    {
      title: t.package3,
      country: "Sri Lanka",
      price: 895,
      duration: 4,
      tags: [t.mirissa, t.yala, t.galle, t.colombo],
      image: beachImg,
    },
    {
      title: t.package4,
      country: "Sri Lanka",
      price: 990,
      duration: 5,
      tags: [t.bentota, t.mirissa, t.ella, t.hillCountry],
      image: bentotaImg,
    },
    {
      title: t.package5,
      country: "Sri Lanka",
      price: 1390,
      duration: 6,
      tags: [t.kitulgala, t.ella, t.arugamBay, t.yala],
      image: adventureImg,
    },
  ];

  return (
    <section className="tour-list-container">
      <div className="container">
        <header className="tour-list-header">
          <h2 className="animate-fadeIn">{t.toursTitle || "Featured Tours"}</h2>
          <p className="animate-fadeIn">{t.toursSubtitle || "Discover unforgettable experiences across the island."}</p>
        </header>
        
        <div className="tour-grid">
          {tourData.map((tour, index) => (
            <TourCard key={index} {...tour} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TourList;
